import { render } from "./TableHead.vue?vue&type=template&id=10e5697a"
import script from "./TableHead.vue?vue&type=script&lang=js"
export * from "./TableHead.vue?vue&type=script&lang=js"
script.render = render

export default script